export default __webpack_public_path__ + "static/media/mastercard.af8851ab.svg";